import styled from "styled-components";

export const Container = styled.div`
    margin-top: 10px;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;

    padding: 8px 16px;
    width: 100%;

    background-color: ${(props) => props.theme.colors.white};
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_100};
`;

export const ContentDetails = styled.div`
    background-color: aqua;
`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    gap: 4px;

    background-color: transparent;
    color: ${(props) => props.theme.colors.primary};
    padding: 2px 4px;
    
    &.button-quantity{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
        color: ${(props) => props.theme.colors.gray.gray_500};
        width: 20px;
        height: 20px;
    }

    &.promotion{
        font-size: 12px;
        border-radius: 4px;
        justify-content: center;
        background-color: ${(props) => props.theme.colors.gray.gray_100};
        color: ${(props) => props.theme.colors.gray.gray_500};
        width: 160px;
    }
    &.promotion-active{
        font-size: 12px;
        border-radius: 4px;
        justify-content: center;
        background-color: ${(props) => props.theme.colors.primary_low};
        color: ${(props) => props.theme.colors.primary};
        width: 160px;
    }
    
    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_50};
        border-radius: 30px;
    }
`;

export const ButtonPromotion = styled.button<{ isActive: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    font-size: 12px;
    border-radius: 4px;
    background-color: ${(props) =>
        props.theme.colors.gray.gray_50
    };
    color: ${(props) => props.isActive ?
        props.theme.colors.primary :
        props.theme.colors.gray.gray_200
    };
    max-width: 160px;
    padding: 2px 4px;

    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
`;

export const Body = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
`;

export const ContentColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ContentInfor = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
`;

export const ContentButton = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const ContentQuantity = styled.div`
    display: flex;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;
    width: 100px;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_100};
`;

export const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;

    font-size: 14px;
    color: ${(props) => props.theme.colors.gray.gray_200};
`;

export const Footer = styled.footer`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
`;

export const Infor = styled.div`
    display: flex;
    flex-direction: column;
    color: ${(props) => props.theme.colors.gray.gray_200};
    
    span{
        color: ${(props) => props.theme.colors.gray.gray_600};
    }
`;

export const Input = styled.input`
    width: 100%;
    text-align: center;

    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
`;

export const SectionInfor = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};
    border-top: 1px solid ${(props) => props.theme.colors.gray.gray_50};
`;

export const Text = styled.p`
    &.subtitle{
        color: ${(props) => props.theme.colors.gray.gray_500};
        font-size: 12px;
    }
    
    &.underline{
        font-size: 14px;
        color: ${(props) => props.theme.colors.gray.gray_200};

        text-decoration: line-through;
    }

    &.title{
        font-size: 18px;
        color: ${(props) => props.theme.colors.primary};
        font-weight: 600;
    }
`;

export const Title = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-weight: 500;
`;